import React from 'react';
import Navbar from '../Navbar';
import Footer from '../Footer';
import {
  LayoutWrapper,
  CenteredContainer,
  ContentWrapper,
  MobileContentWrapper,
} from './style';
import ResponsiveLayout from '../ResponsiveLayout';

const Layout = ({ children }) => {
  return (
    <LayoutWrapper>
      {children}
      <Footer />
    </LayoutWrapper>
  );
};

export const Content = ({ children }) => {
  return (
    <ResponsiveLayout
      renderDesktop={
        <CenteredContainer>
          <ContentWrapper>{children}</ContentWrapper>
        </CenteredContainer>
      }
      renderMobile={<MobileContentWrapper>{children}</MobileContentWrapper>}
    />
  );
};

export * from './style';
export default Layout;
